import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMAIL_PATTERN } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'report-missing-bakery-form',
  templateUrl: './report-missing-bakery-form.component.html'
})
export class ReportMissingBakeryFormComponent {
  @Input() isSuccess = false;
  @Output() onSend = new EventEmitter<any>();
  @Output() onFormChange = new EventEmitter<void>();

  public form: FormGroup;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  constructor(private _fb: FormBuilder) {
    this.form = this._fb.group({
      userName: ['', [Validators.required, Validators.maxLength(32)]],
      bakeryName: ['', [Validators.required, Validators.maxLength(64)]],
      city: ['', [Validators.required, Validators.maxLength(64)]],
      message: ['', [Validators.required, Validators.maxLength(512)]],
      email: ['', [Validators.required, Validators.maxLength(128)]]
    });
  }

  public send() {
    const value = this.form.value;
    value.message = 'Looks like bakery is missing: ' + value.bakeryName + '.\n' + value.message;
    this.onSend.emit(value);
  }
}
